let recaptchaVerifier: unknown = null;

export async function getRecaptchaVerifier(containerId = 'recaptcha-container') {
  if (recaptchaVerifier) return recaptchaVerifier;
  const [{ auth }, { RecaptchaVerifier }] = await Promise.all([
    import('../config/firebase.js'),
    import('firebase/auth'),
  ]);
  recaptchaVerifier = new RecaptchaVerifier(auth, containerId, { size: 'invisible' });
  return recaptchaVerifier;
}

export function resetRecaptchaVerifier() {
  const prev = recaptchaVerifier as { clear?: () => void } | null;
  try {
    prev?.clear?.();
  } catch {
    // Best-effort dispose of a verifier bound to an unmounted container.
  }
  recaptchaVerifier = null;
}
